import React, { PropsWithChildren, PureComponent } from 'react';
import { ManagedColumn } from 'app/common/table/ManagedTable';
import { Popover } from 'antd';
import { RenderFunction } from 'antd/lib/_util/getRenderPropValue';
import './TableColumnTooltip.css';

export interface TableColumnTooltip {
    title?: string;
    content: React.ReactNode | RenderFunction;
}

export interface TableColumnTooltipProps {
    column: ManagedColumn<any>;
}

export function generateTooltipContent(contentKeyValue: Array<[string, string]>): React.ReactNode {
    const listOfParagraphs = [];
    contentKeyValue.forEach(([key, value]) => {
        listOfParagraphs.push(
            <p key={key}>
                <b>{key}</b>&nbsp;{value}
            </p>,
        );
    });
    return <span>{listOfParagraphs}</span>;
}

export default class TableColumnTooltipComponent extends PureComponent<PropsWithChildren<TableColumnTooltipProps>> {
    //extra padding because when the title is just a letter it's a very small area to mouse over to display the tooltip
    render() {
        if (this.props.column?.extra?.tooltip) {
            return (
                <Popover
                    content={this.getContent(this.props.column.extra.tooltip.content)}
                    title={this.props.column.extra.tooltip.title}
                    mouseEnterDelay={0.3}>
                    <span style={{ paddingLeft: '2px', paddingRight: '4px' }}>{this.props.children}</span>
                </Popover>
            );
        } else {
            return this.props.children;
        }
    }

    private getContent(content) {
        return <div className="tooltipColumn">{content}</div>;
    }
}
